import { AXIOS_INSTANCE_ONBOARDING } from 'utilities/db';
import { useQuery } from 'react-query';

export const useFetchExistingPlanHook = (keyName, brandId) => {
  const { status, data, error, isFetching, isLoading, refetch } = useQuery(
    [keyName, brandId],
    () => getData(brandId),
    {
      enabled: !!brandId
      // refetchInterval: 60000
    }
  );

  return {
    existingPlanStatus: status,
    existingPlanData: data,
    existingPlanError: error,
    existingPlanFetching: isFetching,
    existingPlanLoading: isLoading,
    existingPlanRefetch: refetch
  };
};

const getData = async (brandId) => {
  let { data } = await AXIOS_INSTANCE_ONBOARDING.get(
    `/brands/getBrandBundle/${brandId}`
  );
  return data;
};
